/** Диапазон дат. Используется для установки диапазона возможных дат и выбора значений в календаре  */
export type Period = { min: Date; max: Date }
/** Тематика бизнеса */
export type Theme = { id: number; name: string; category_id?: string }

/** Данные для графика */
export type GraphPayload = { date: Date; value: string }[]

/** Данные для топа категорий */
export type CategoryGraphPayload = { count: number; name: string }[]

export type RequestPayload = {
  data: {
    ad_count: GraphPayload
    ad_expenses: GraphPayload
    cpj: GraphPayload
    cpm: GraphPayload
    cpc: GraphPayload
    cr: GraphPayload
    expenses_average: GraphPayload
    click_per_ad_average: GraphPayload
    view_per_ad_average: GraphPayload
    view_per_advertiser_average: GraphPayload
    category_top: CategoryGraphPayload
  }
  period: Period
  theme: Theme[]
}

export type GraphComponentProps = {
  data?: GraphPayload
  graphHeight?: number
}

export type GraphComponentPropsNew = {
  data?: GraphPayload
  graphHeight?: number
  unit: string
}

export type Data = {
  [x: string]: string | number | undefined
} & {
  date: Date
}

/** Данные для кастомной легенды графиков */
export type LegendData = {
  color: string
  title: string | React.ReactNode
  tooltip?: string | React.ReactNode
}[]

export enum ChartSize {
  LARGE = 300,
  MEDIUM = 220,
  SMALL = 200
}
